module.exports = __webpack_public_path__ + "static/media/folder_icon.db0c1805.svg";